/**
 * Phone Agent feature gate.
 *
 * Temporary store-based allowlist while we test the Phone Agent end-to-end.
 * Once we're ready for general availability, either:
 *   - return `true` unconditionally, or
 *   - delete this file and remove the call sites.
 *
 * Kept separate from dashboardTabRestrictions (which is email-based for
 * blocking tabs per-user) because this gates per-STORE, not per-user.
 */

const PHONE_AGENT_ENABLED_STORE_IDS = new Set([
  '1e31fec9-882d-44b4-b870-1899f759764b', // Testing Store
  '1613f551-d058-4c38-90a8-6dbf4763c4bd', // Agile Stockton
  '0d5edf17-24fd-4a77-8b31-c39ee6c31e43', // Mirage Furnishings
  'a1e9199f-5183-4294-86f5-af53d2916ec0', // Mikes Testing Store
]);

/**
 * @param {string | null | undefined} storeId
 * @returns {boolean}
 */
export function isPhoneAgentEnabledForStore(storeId) {
  if (!storeId) return false;
  return PHONE_AGENT_ENABLED_STORE_IDS.has(storeId);
}